import {Directive, ElementRef, Attribute, OnInit} from '@angular/core';
import {uniqueId} from './util';

@Directive({
    selector: '[card-number]',
    host: {
        '[attr.name]': 'name',
    },
    standalone: false
})
export class NgxCardNumberTemplate implements OnInit {
	constructor(public elementRef: ElementRef, @Attribute('name') public name: string) {}

	ngOnInit() {
		this.name = this.name || uniqueId('number');
	}
}

@Directive({
    selector: '[card-name]',
    host: {
        '[attr.name]': 'name',
    },
    standalone: false
})
export class NgxCardNameTemplate implements OnInit {
	constructor(public elementRef: ElementRef, @Attribute('name') public name: string) {}

	ngOnInit() {
		this.name = this.name || uniqueId('name');
	}
}

@Directive({
    selector: '[card-expiry]',
    host: {
        '[attr.name]': 'name',
    },
    standalone: false
})
export class NgxCardExpiryTemplate implements OnInit {
	constructor(public elementRef: ElementRef, @Attribute('name') public name: string) {}

	ngOnInit() {
		this.name = this.name || uniqueId('expiry');
	}
}

@Directive({
    selector: '[card-cvc]',
    host: {
        '[attr.name]': 'name',
    },
    standalone: false
})
export class NgxCardCvcTemplate implements OnInit {
	constructor(public elementRef: ElementRef, @Attribute('name') public name: string) {}

	ngOnInit() {
		this.name = this.name || uniqueId('cvc');
	}
}
